import ExplorerMap from './explorer/explorer-map';
import ExplorerList from './explorer/explorer-list';
import axios from 'axios';

document.addEventListener('DOMContentLoaded', () => {
  // explorer initial data
  const data = new FormData();
  data.append('action', 'get_initial_data');

  axios
    // eslint-disable-next-line no-undef
    .post(explorer.ajax_url, data)
    .then((response) => {
      // explorer map
      const explorerMap = new ExplorerMap(response.data);

      explorerMap.init();

      // explorer list
      const explorerList = new ExplorerList(response.data);

      explorerList.init();
    });

  // layover
  const layover = document.querySelector('.page-explorer--layover');
  document.querySelector('.page-explorer--layover-close').addEventListener('click', () => {
    layover.classList.remove('toggled');
  });
});
